/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareLinkedEntity} from '../fw/MetaDataHelper.ts';
import * as Permission from "../util/Permission";

export default declareLinkedEntity({
    entity: "profileItemDefs",
    graphQL: "ProfileItemDef",
    storageType: 'central',
    name: "Profile Item Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultTitle: (data) => {
        return data['name'];
    },
    parentRelation: "profileItemDefs",
    isPublic: true,
    defaultOrder: ['field'],
    fields: (types) => { return {
        id: {
            name: "Profile Item Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
        },
        description: {
            name: "Description",
            type: "text",
            defaultValue: "",
            translatable: true,
        },
        field: {
            name: "Field",
            type: "string",
        },
        fieldName: {
            name: "Field",
            type: "string",
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getFieldDefName",
        },
        fieldDef: {
            name: "Metadata",
            type: "relation",
            to: () => types['fieldDefs'],
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getFieldDef",
        },
        entityDef: {
            name: "Metadata",
            type: "relation",
            to: () => types['entityDefs'],
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getEntityDef",
        },
        profileDef: {
            name: "Profile Definition",
            type: "relation",
            to: () => types['profileDefs'],
            defaultValue: (profileDefs) => {
                return profileDefs['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        requirement: {
            name: "Requirement",
            type: "enum",
            defaultValue: "2",
            values: {
                "4": {
                    name: "Notice",
                },
                "3": {
                    name: "Info",
                },
                "2": {
                    name: "Warning",
                },
                "1": {
                    name: "Error",
                },
            }
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
